"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressExternal = void 0;
class AddressExternal {
    constructor(bits) {
        this.bits = bits;
    }
}
exports.AddressExternal = AddressExternal;
